import createDictionary from "@elsa-zku/lib/helpers/createDictionary";
import { Values } from "src/interfaces/models";

export const APARTMENT_TYPE = {
  FLAT:       1,
  APARTMENT:  2,
  COMMERCIAL: 3,
} as const;

export type APARTMENT_TYPE_VALUE = Values<typeof APARTMENT_TYPE>;

const list = [
  {
    id:               APARTMENT_TYPE.FLAT,
    label:            'Квартира',
    labelShort:       'кв.',
    icon:             require('@elsa-zku/lib/icons/ApartmentLiving.svg'),
    calculationField: 'tariff' as const,
  },
  {
    id:               APARTMENT_TYPE.APARTMENT,
    label:            'Апартаменты',
    labelShort:       'ап.',
    icon:             require('@elsa-zku/lib/icons/ApartmentApartment.svg'),
    calculationField: 'tariff_apartment' as const,
  },
  {
    id:               APARTMENT_TYPE.COMMERCIAL,
    label:            'Коммерческое',
    labelShort:       'ком.',
    icon:             require('@elsa-zku/lib/icons/ApartmentBusiness.svg'),
    calculationField: 'tariff_commercial' as const,
  },
]

export const apartmentTypes = createDictionary({ list, formatLabel: (item) => item.label });
